import { render, staticRenderFns } from "./PageLeftSidebar.vue?vue&type=template&id=ff0f1ca4"
import script from "./PageLeftSidebar.vue?vue&type=script&lang=js"
export * from "./PageLeftSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports